// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Dropdown as HeroDropdown } from "@heroui/react";
import type { ComponentProps } from "react";

export type DropdownProps = ComponentProps<typeof HeroDropdown.Root>;
export type DropdownPopoverProps = ComponentProps<typeof HeroDropdown.Popover>;
export type DropdownMenuProps = ComponentProps<typeof HeroDropdown.Menu>;
export type DropdownItemProps = ComponentProps<typeof HeroDropdown.Item>;

export const Dropdown = Object.assign(HeroDropdown.Root, {
  Root: HeroDropdown.Root,
  Trigger: HeroDropdown.Trigger,
  Popover: HeroDropdown.Popover,
  Menu: HeroDropdown.Menu,
  Item: HeroDropdown.Item,
  Section: HeroDropdown.Section,
});
